import { Icon } from 'components';
import { useCallback, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import './Header.scss';

type Props = {
    backIcon?: boolean;
    saveIcon?: boolean;
    helpIcon?: boolean;
    widthBanner?: string;
    heightBanner?: string;
    textHeader?: string;
    onBack?: () => void;
    onSubmit?: () => void;
    onHelp?: () => void;
    isMissionDetail?: boolean;
};

/**
 * header
 * @returns
 */
const Header = (props: Props): JSX.Element => {
    const {
        backIcon = false,
        saveIcon = false,
        helpIcon = false,
        textHeader,
        onBack,
        onSubmit,
        onHelp,
        isMissionDetail,
    } = props;

    /**
     * handle go back when click back icon
     */
    const handleGoBack = useCallback(() => {
        onBack && onBack();
    }, [onBack]);

    /**
     * handle save when click save icon
     */
    const handleSave = useCallback(() => {
        onSubmit && onSubmit();
    }, [onSubmit]);

    /**
     * handle help when click help icon
     */
    const handleHelp = useCallback(() => {
        onHelp && onHelp();
    }, [onHelp]);

    return useMemo(
        () => (
            <div className="header-container">
                <Row>
                    <Col className="d-flex justify-content-start cursor-pointer" xs={2}>
                        {backIcon && (
                            <div onClick={handleGoBack}>
                                {isMissionDetail ? <Icon.BackIconMissionDetail /> : <Icon.BackIcon />}
                            </div>
                        )}
                    </Col>
                    <Col className="banner-header" xs={8}>
                        {textHeader}
                    </Col>
                    <Col className="d-flex justify-content-center cursor-pointer" xs={2}>
                        {saveIcon && (
                            <div onClick={handleSave}>
                                <Icon.SaveIcon />
                            </div>
                        )}
                        {helpIcon && (
                            <div onClick={handleHelp}>
                                <Icon.Help height="36" width="40" />
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        ),
        [backIcon, handleGoBack, handleHelp, handleSave, helpIcon, saveIcon, textHeader],
    );
};

export default Header;
